































































































import { MainLayoutVue } from "fs-pb-vue2/vueModels/layouts/MainLayoutVue";
import MainNavigation from "@/components/navigation/MainNavigation.vue";
import ServerCommandsController from "@/components/app/ServerCommandsController.vue";
import CommonFooter from "@/components/navigation/CommonFooter.vue";
import { Component } from "vue-property-decorator";
import AppError from "@/components/app/AppError.vue";
import AuthCheck from "@/components/auth/AuthCheck.vue";
import Chat from "@/components/app/chat.vue";
import ShortCodeSetModal from "@/components/settings/ShortCodeSetModal.vue";
import MobileNavigation from "@/components/navigation/MobileNavigation.vue";

@Component({
  components: { MainNavigation, CommonFooter, AppError, AuthCheck, ServerCommandsController, Chat, ShortCodeSetModal, MobileNavigation }
})
export default class MainLayout extends MainLayoutVue {
  async created() {
    await this.init();
    await this.personStore.fetchUserDocumentTypes();
    await this.personStore.fetchSubscriptions();
  }

  mounted() {
    this.suggestShortCode = this.isMobileBrowser && window.localStorage.getItem('dontSuggestToCreateShortCode') != "1" &&
    window.localStorage.getItem('loginWithoutPasswordOn') != "1";
  }

  suggestShortCode: boolean = true;

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  dontSuggestPinAction() {
    window.localStorage.setItem('dontSuggestToCreateShortCode', '1');
    this.suggestShortCode = false;
  }

  beforeDestroy() {
    this.resetStoreStates();
  }
}
